import { SVGProps, Ref, forwardRef } from 'react';

export const MinusOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path d="M13 7.3v1.4H3V7.3z" fill="currentColor" />
        </g>
    </svg>
));
MinusOutlinedSize16Glyph.displayName = 'MinusOutlinedSize16Glyph';
